module.exports = 'warn'